import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { attrs: { flat: "" } },
    [
      _c(
        VCardText,
        [
          _c("p", [
            _c("span", { staticStyle: { "background-color": "yellow" } }, [
              _vm._v("Texto Alterado"),
            ]),
            _c("span", { staticClass: "ml-4" }, [
              _vm._v(
                "* Os textos marcados em amarelo tiveram alterações em relação a versão anterior."
              ),
            ]),
          ]),
          _vm._l(_vm.itensHistorico, function (item) {
            return _c("historico-responsabilidade-item", {
              key: item.id,
              attrs: { item: item },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }